
import Vue from 'vue'

import Command from "@/utils/command";
Vue.use(Command);

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import '@/styles/index.scss' // global css
import '@/assets/iconfont/iconfont.css' //iconfont图标库
import "@/utils/filters"

import "@/utils/time"
import App from './App'
import store from './store'
import router from '@/utils/router'

import 'vue-ztree-2.0/dist/vue-ztree-2.0.css'

import 'font-awesome/css/font-awesome.min.css'

import "@/utils/directives"

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)



//import '@/icons' // icon
//import '@/permission' // permission control


// set ElementUI lang to EN
Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)

Vue.config.goodsionTip = false

global.gApp = new Vue({
      router,
      store,
      render: h => h(App)
    })

gApp.config = process.env;	
gApp.$mount("#app");
